import { Button, Spinner } from 'react-bootstrap';
import { FaCheck } from 'react-icons/fa';
import { discountReasonLabel, formatDiscountValue } from '../../utils/activeGlobalDiscount';
import '../../assets/styles/action-feedback.css';
import { feedbackClassName } from '../../hooks/useActionFeedback';

const ApplyGlobalDiscountButton = ({
    discount,
    onApply,
    applying = false,
    succeeded = false,
    disabled = false,
    error = '',
    companyName = '',
    showLabel = false,
}) => {
    if (!discount) {
        return null;
    }

    const valueLabel = formatDiscountValue(discount);
    const reasonLabel = discountReasonLabel(discount);
    const reasonPhrase = reasonLabel.toLowerCase();
    const actionLabel = valueLabel
        ? `Aplicar ${reasonPhrase} de ${valueLabel}`
        : `Aplicar ${reasonPhrase}`;

    return (
        <div className="global-discount-apply">
            {showLabel ? (
                <span className="global-discount-apply-title">{reasonLabel}</span>
            ) : null}
            <Button
                type="button"
                size="sm"
                className={`global-discount-apply-btn ${succeeded ? 'is-added action-feedback-success' : ''} ${feedbackClassName(succeeded ? 'success' : null)}`}
                onClick={onApply}
                disabled={applying || disabled || succeeded}
                aria-label={actionLabel}
            >
                {succeeded ? (
                    <>
                        <FaCheck size={12} />
                        <span>Listo</span>
                    </>
                ) : applying ? (
                    <>
                        <Spinner animation="border" size="sm" role="status" />
                        <span>Aplicando...</span>
                    </>
                ) : (
                    <>
                        <span>Aplicar</span>
                        {valueLabel ? <span className="global-discount-apply-value">{valueLabel}</span> : null}
                    </>
                )}
            </Button>
            {companyName ? (
                <small className="global-discount-apply-hint">Se aplica a {companyName}.</small>
            ) : null}
            {error ? <small className="text-danger d-block">{error}</small> : null}
        </div>
    );
};

export default ApplyGlobalDiscountButton;
